import { Helmet } from 'react-helmet-async';
import { CountryListView } from 'src/sections/country/view';

export default function CountryListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Country</title>
      </Helmet>
      <CountryListView />
    </>
  );
}
